import { createRequest } from "helpers/tools";

export const sendVtigerData = async (data) => {
    return await createRequest({
        suffix: "vtiger",
        method: "post",
        payload: data,
        handleError: false,
    });
};

export const vtigerMapping = async (data, id) => {
    return await createRequest({
        suffix: `vtiger/update/${id}`,
        method: "put",
        payload: data,
        handleError: false,
    });
};

export const getVtigerMapping = async (id) => {
    return await createRequest({
        suffix: `vtiger/${id}/fields`,
        method: "get",
        handleError: false,
    });
};

export const getVtigerTest = async (id) => {
    return await createRequest({
        suffix: `vtiger/${id}/preview`,
        method: "get",
        handleError: false,
    });
};
